import ContainerImagePanel from './ContainerImagePanel';
import PrivateRegistry from './PrivateRegistry';

const ContainerImage: React.FC = () => (
  <>
    <ContainerImagePanel />
    <PrivateRegistry />
  </>
);

export default ContainerImage;
